import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Checkbox, FormControlLabel } from '@mui/material';

// Styles
import './checkbox.scss';

const Check = (props) => {
	const {
		id,
		size,
		value,
		onChange,
		label,
		checkedIcon,
		unCheckedIcon,
		required,
		disabled,
	} = props;

	let checked = value
	if (!checked || checked == undefined)
		checked = false

	return (
		<FormControlLabel
			control={
				<Checkbox
					id={id}
					className={cx(`check-color ${size && 'checkbox-' + size}`, props.className)}
					checked={value || false}
					onChange={(event) => {
						if (onChange) onChange(event.target.checked);
					}}
					name={id}
					checkedIcon={checkedIcon}
					icon={unCheckedIcon}
					disabled={disabled}
				/>
			}
			label={(
				<>
					<span className={`${size && 'label-' + size}`}>{label}</span>
					{required && (
						<span className="text-danger"> *</span>
					)}
				</>
			)}
		/>
	);
};

export default Check;

Check.propTypes = {
	id: PropTypes.string.isRequired,
	value: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	label: PropTypes.string,
	required: PropTypes.bool,
};

Check.defaultProps = {
	requird: false,
}